import { render } from "./AppsSection.vue?vue&type=template&id=38ded1f6"
import script from "./AppsSection.vue?vue&type=script&lang=js"
export * from "./AppsSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__